/* eslint-disable import/no-unresolved */
import { ButtonProps as MuiButtonProps } from "@material-ui/core/Button";
import React from "react";

import AppStore from "../../../../assets/logo/appStore.png";
import Playstore from "../../../../assets/logo/playstore.png";
import * as S from "./styles";

interface Props extends MuiButtonProps {
  buttonType: "AppStore" | "PlayStore";
}

export default function MyComponent({ buttonType, ...rest }: Props) {
  return (
    <S.Container {...rest}>
      <S.Background>
        {buttonType === "PlayStore" ? (
          <img src={Playstore} alt="" style={{ width: 142, height: 36 }} />
        ) : (
          <img src={AppStore} alt="" style={{ width: 142, height: 36 }} />
        )}
      </S.Background>
    </S.Container>
  );
}
